
<div class="info-primaire-produit h-100">
  <b-container class="p-0">
    <b-row class="padding-texte">
      <b-col class="flex-column infoJeu col-8 col-sm-7 col-xxl-8">
        <b-row class="graphik_bold card-header__category">
          <!--TODO: mettre le symbole pour indiquer la nouveauté du produit-->
          <div class="sur-titre" v-html="surTitre" />
        </b-row>
        <b-row
          class="card-header__title graphik_bold align-items-center titre pb-0"
          v-html="mixinProduitCasino_getTitre()"
        />
        <b-row>
          <div class="min-bet montant-mise" v-html="mixinProduitCasino_getMiseMinMax()" />
        </b-row>
      </b-col>
      <b-col class="d-flex bouton-jouer col-4 col-sm-5 col-xxl-4 pt-1">
        <div class="w-100 d-flex justify-content-end">
          <span @click.capture="gaPreventClick">
            <Hyperlien
              :aria-label="mixinProduitCasino_getTitre(false)"
              :content="{
                texte: getTexteBoutonJouer,
                type: 'boutonPrimaire',
                theme: 'themeClair',
                lien: content.produit.lienInternePageProduit,
              }"
            />
          </span>
        </div>
      </b-col>
    </b-row>
  </b-container>
</div>
